import styles from "../assets/styles/DivorceInsurance.module.css";
import DivorceInsuranceError from "../components/DivorceInsuranceError";
import DivorceInsuranceLoading from "../components/DivorceInsuranceLoading";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

import ResultBackground from "../assets/images/DivorceInsurance/result_background.jpg";
import LinkShareImage from "../assets/images/DivorceInsurance/link.png";
import KakaoShareImage from "../assets/images/DivorceInsurance/kakao.png";
import DownloadImage from "../assets/images/DivorceInsurance/download.png";
import XShareImage from "../assets/images/DivorceInsurance/X.png";
import PressAndSave from "../assets/images/DivorceInsurance/pressAndSave.png";
import ShareText from "../assets/images/DivorceInsurance/shareText.png";
import TryButton from "../assets/images/DivorceInsurance/try.png";
import Line from "../assets/images/DivorceInsurance/line.png";

// ?nickname=홍길동&choice=1,2,1234,3,4,1&subject7=정이%20떨어질%20때&subject8=살다보면%20별일%20다%20있다.%20그냥%20넘겨라.

axios.defaults.timeout = 29000;

export default function DivorceInsurance() {
  const [isLoading, setIsLoading] = useState(true);
  const [isFetched, setIsFetched] = useState(false);
  const [isIphone, setIsIphone] = useState(false);
  const [isError, setIsError] = useState(false);
  const [ticketId, setTicketId] = useState("");
  const [fetchCount, setFetchCount] = useState(0);
  const [searchParams] = useSearchParams();
  const [nickname, setNickname] = useState("");
  const [percentA, setPercentA] = useState("00");
  const [percentB, setPercentB] = useState("00");
  const [percentC, setPercentC] = useState("00");
  const [percentD, setPercentD] = useState("00");
  const [adjective, setAdjective] = useState("과도하게 현실적인");
  const [insuranceAdjective, setInsuranceAdjective] =
    useState("경제 우선 회복형");
  const [oneLine, setOneLine] = useState(
    "너와 나의 행복에 책임감을 느껴,\n 하지만 서로의 심적 경제적 안전도 지키자!"
  );
  const [total, setTotal] = useState("균형 잡힌 이혼 후 재정 지원 및 보호");
  const [letterContent, setLetterContent] = useState([
    {
      title: "고액 위자료 대응 특별 보장",
      contents: [
        {
          content:
            "피보험자가 이혼 시, 법적으로 지급해야 하는 위자료의 일정 부분을 보험금으로 지원합니다.",
          specifics: [
            "지급 한도: 연봉 50%까지 보장 (단, 최대 보장 한도는 3억 원)",
            "가입자가 이혼 횟수 3회 초과 시, 위자료 부담을 고려하여 추가 보장 옵션 제공",
          ],
        },
        {
          content:
            "'자존심 플렉스 특약' 가입 시, 위자료 지급 후 생활 안정화를 위한 긴급 생활비 대출 지원 가능",
          specifics: [],
        },
      ],
      summary: [
        "위자료 부담으로 인한 금전적 부담을 최소화하는 특약으로 가입자의 경제적 안정을 위한 긴급 대응 시스템 제공",
      ],
    },
    {
      title: "재정 재건 지원 프로그램",
      contents: [
        {
          content: "이혼 후 경제적 재기를 위한 맞춤형 자산 관리 컨설팅 제공",
          specifics: [],
        },
        {
          content:
            "'이혼 후폭풍 대비 펀드' 가입 가능 (월 27,900원 납부 시, 1억 원까지 예비 자산 운용)",
          specifics: [],
        },
        {
          content:
            "사업자 등록비 및 초기 창업 자금 일부 지원 (이혼 후 직장생활 지속이 어려운 경우)",
          specifics: [],
        },
      ],
      summary: [
        "이혼 후 경제적 자립을 위한 재정 재건 프로그램으로 재혼을 위한 경제적 안정화를 위한 자금 지원 시스템",
      ],
    },
    {
      title: "심리적 & 사회적 회복 프로그램",
      contents: [
        {
          content:
            "전담 심리 상담 서비스 제공 (이혼 후 스트레스 해소 및 자존감 회복을 위한 1:1 전문가 상담)",
          specifics: [
            "첫 6개월간 상담비 전액 지원",
            "필요 시 '전처(前妻) 트라우마 극복' 프로그램 추가 제공",
          ],
        },
        {
          content: "사회적 이미지 복구 지원",
          specifics: [
            "'이혼경력 브랜딩 특약' 가입 시, 프로필 관리 전문가가 신뢰 회복을 위한 이미지 컨설팅 진행",
            "필요 시 '성공적 연애 재출발 패키지' (맞춤형 연애 코칭 및 새로운 인연 소개) 제공",
          ],
        },
      ],
      summary: [
        "이혼 후 심리적 안정과 사회적 회복을 위한 프로그램으로 이혼 후 새로운 인간관계 형성을 위한 네트워크 구축 시스템",
      ],
    },
  ]);
  const [imageData, setImageData] = useState("");
  const [fontReady, setFontReady] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setIsError(false);

    if (/iPhone|iPad/i.test(navigator.userAgent)) {
      setIsIphone(true);
    }
    let _nickname = searchParams.get("nickname");
    setNickname(_nickname);

    const getTicketData = async () => {
      let ticketId = searchParams.get("ticketId");
      let choice = searchParams.get("choice");
      let subject7 = searchParams.get("subject7");
      let subject8 = searchParams.get("subject8");

      if (
        (!ticketId || ticketId === "") &&
        _nickname &&
        choice &&
        subject7 &&
        subject8
      ) {
        sendContentToServer(_nickname, choice, subject7, subject8);
      } else if (ticketId && !choice && !subject7 && !subject8) {
        console.log("getting result from server");
        getResultFromServer(ticketId);
      } else {
        console.log("no ticketId or content");
        setIsLoading(false);
        setIsError(true);
      }
    };
    (async () => {
      try {
        const fonts = [
          new FontFace("NotoSansKR-Black", 'url("NotoSansKR-Black.ttf")'),
          new FontFace("NotoSansKR-Bold", 'url("NotoSansKR-Bold.ttf")'),
          new FontFace(
            "NotoSansKR-ExtraBold",
            'url("NotoSansKR-ExtraBold.ttf")'
          ),
          new FontFace("NotoSansKR-Medium", 'url("NotoSansKR-Medium.ttf")'),
        ];

        await Promise.all(fonts.map((font) => font.load()));
        fonts.forEach((font) => document.fonts.add(font));
        setFontReady(true);
      } catch (error) {
        console.error("Font loading failed:", error);
      }
    })();
    getTicketData();
  }, []);

  useEffect(() => {
    if (
      isFetched &&
      percentA &&
      percentB &&
      percentC &&
      percentD &&
      adjective &&
      insuranceAdjective &&
      oneLine &&
      total &&
      letterContent &&
      fontReady
    ) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = ResultBackground;
      img.onload = () => {
        const viewportWidth = window.innerWidth;
        const maxWidth = 500;
        const imageWidth = Math.min(viewportWidth, maxWidth);
        const imageHeight = (imageWidth / img.width) * img.height;

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, img.width, img.height);

        ctx.font = "50px NotoSansKR-Bold";
        ctx.fillStyle = "white";

        drawTextBox(ctx, nickname, img.width / 2, 430, canvas.width, 1.4, true);

        ctx.font = "37px NotoSansKR-Bold";
        ctx.fillStyle = "#fe7312";

        drawTextBox(ctx, percentA, 78 + 90, 896, canvas.width, 1.4, true);
        drawTextBox(ctx, percentB, 297 + 90, 896, canvas.width, 1.4, true);
        drawTextBox(ctx, percentC, 515 + 90, 896, canvas.width, 1.4, true);
        drawTextBox(ctx, percentD, 733 + 90, 896, canvas.width, 1.4, true);

        ctx.font = "54px NotoSansKR-Bold";
        ctx.fillStyle = "white";

        drawTextBox(
          ctx,
          adjective,
          img.width / 2,
          1048,
          canvas.width,
          1.4,
          true
        );
        drawTextBox(
          ctx,
          nickname + " 님을 위한",
          img.width / 2,
          1128,
          canvas.width,
          1.4,
          true
        );
        drawTextBox(
          ctx,
          insuranceAdjective + " 보장!",
          img.width / 2,
          1208,
          canvas.width,
          1.4,
          true
        );

        ctx.font = "39px NotoSansKR-Bold";
        ctx.fillStyle = "black";

        drawTextBox(
          ctx,
          nickname + "님을 위한 맞춤형 이혼 보험 설계",
          img.width / 2,
          1405,
          canvas.width,
          1.4,
          true,
          true
        );

        ctx.font = "36px NotoSansKR-Bold";
        ctx.fillStyle = "black";

        const oneLineLines = countLines(ctx, oneLine, canvas.width - 150);
        let addSome = 0;
        if (oneLineLines > 1) {
          addSome = -40;
        }
        drawTextBox(
          ctx,
          oneLine,
          img.width / 2,
          1540 + addSome / 4,
          canvas.width - 150,
          1.4,
          true
        );

        const middleText = " 당신을 위한  ";
        const insuranceAdjectiveText = "‘" + insuranceAdjective + "’";
        const lastText = " 보장!";
        let textMetrics = ctx.measureText(middleText);
        const textWidthM = textMetrics.width;
        textMetrics = ctx.measureText(insuranceAdjectiveText);
        const textWidthI = textMetrics.width;
        textMetrics = ctx.measureText(lastText);
        const textWidthL = textMetrics.width;
        let totalWidth = textWidthM + textWidthI + textWidthL;
        let startX = img.width / 2 - totalWidth / 2;

        ctx.fillStyle = "black";
        drawTextBox(
          ctx,
          middleText,
          startX,
          1600 - addSome / 2,
          canvas.width,
          1.4,
          false,
          false
        );
        ctx.fillStyle = "#fe7312";
        drawTextBox(
          ctx,
          insuranceAdjectiveText,
          startX + textWidthM,
          1600 - addSome / 2,
          canvas.width,
          1.4,
          false,
          false
        );
        ctx.fillStyle = "black";
        drawTextBox(
          ctx,
          lastText,
          startX + textWidthI + textWidthM,
          1600 - addSome / 2,
          canvas.width,
          1.4,
          false,
          false
        );

        ctx.font = "36px NotoSansKR-Bold";
        ctx.fillStyle = "black";
        drawTextBox(
          ctx,
          nickname + "님을 위한",
          img.width / 2,
          1675,
          canvas.width - 150,
          1.4,
          true
        );

        drawTextBox(
          ctx,
          "<" + total + "> 특약",
          img.width / 2,
          1715,
          canvas.width - 150,
          1.4,
          true
        );

        ctx.font = "28px NotoSansKR-Bold";
        ctx.fillStyle = "black";
        let lineCount = 0;
        for (let i = 0; i < letterContent.length; i++) {
          if (lineCount > 17) break;
          const letter = letterContent[i];
          const title = letter.title;
          const summary = letter.summary;
          ctx.font = "28px NotoSansKR-Bold";
          drawTextBox(
            ctx,
            (i + 1).toString() + ". " + title,
            73,
            1800 + lineCount * 41,
            canvas.width - 150,
            1.4,
            false
          );
          lineCount += 1;
          ctx.font = "28px NotoSansKR-Medium";
          for (let j = 0; j < summary.length; j++) {
            drawTextBox(
              ctx,
              "    - ",
              73,
              1800 + lineCount * 41,
              canvas.width - 150,
              1.4,
              false
            );

            drawTextBox(
              ctx,
              summary[j],
              116,
              1804 + lineCount * 41,
              canvas.width - 180,
              1.4,
              false
            );

            lineCount += countLines(ctx, summary[j], canvas.width - 180) + 1;
          }
        }

        const base64Image = canvas.toDataURL("image/png");
        setImageData(base64Image);

        setIsLoading(false);
        setIsError(false);
      };
    }
  }, [
    isFetched,
    percentA,
    percentB,
    percentC,
    percentD,
    adjective,
    insuranceAdjective,
    oneLine,
    total,
    letterContent,
    fontReady,
  ]);

  const sendContentToServer = (_nickname, choice, subject7, subject8) => {
    const data = {
      nickname: _nickname,
      choice: choice,
      subject7: subject7,
      subject8: subject8,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios
      .post(process.env.REACT_APP_ASK_STAR_API_URL, data, config)
      .then((res) => {
        window.location.href = `/divorce-insurance?ticketId=${res.data.ticketId}&nickname=${_nickname}`;
      })
      .catch((err) => {
        setIsError(true);
        setIsLoading(false);
        console.log(err);
      });
  };

  const getResultFromServer = (ticketId) => {
    setTicketId(ticketId);

    const data = {
      ticketId: ticketId,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios
      .post(process.env.REACT_APP_ASK_STAR_API_URL, data, config)
      .then((res) => {
        if (res.data.answer !== "") {
          const answer = res.data.answer;
          const content = res.data.content;
          setNickname(content[0]);
          setAdjective(answer.adjective);
          setInsuranceAdjective(answer.insuranceAdjective);
          setOneLine(answer.oneLine);
          setTotal(answer.total);
          setLetterContent(answer.special);

          //calculate percentage
          const choices = [
            content[9],
            content[10],
            content[11],
            content[12],
            content[13],
            content[14],
          ];

          let count = [0, 0, 0, 0]; // 기준 한들 전만 나래 // 책임 감성 신중 현실
          if (choices[1] === "1") {
            count[0]++;
            count[1]++;
          } else if (choices[1] === "2") {
            count[2]++;
          } else if (choices[1] === "3") {
            count[3]++;
          }

          // choices[2] is "nnnn" form like "1234"
          // get the max index of the choice and add 1 to get the index of the count
          // if max value is not single then add to all indices
          const max = Math.max(...choices[2].split("").map((x) => parseInt(x)));
          const maxIndex = choices[2]
            .split("")
            .findIndex((x) => parseInt(x) === max);
          if (choices.filter((x) => x === max).length > 1) {
            for (let i = 0; i < count.length; i++) {
              if (i === 0) {
                count[2]++;
              } else if (i === 1) {
                count[1]++;
              } else if (i === 2) {
                count[3]++;
              } else if (i === 3) {
                count[0]++;
              }
            }
          } else {
            if (maxIndex === 0) {
              count[2]++;
            } else if (maxIndex === 1) {
              count[1]++;
            } else if (maxIndex === 2) {
              count[3]++;
            } else if (maxIndex === 3) {
              count[0]++;
            }
          }

          if (choices[3] === "1") {
            count[2]++;
          } else if (choices[3] === "2") {
            count[0]++;
          } else if (choices[3] === "3") {
            count[1]++;
          } else if (choices[3] === "4") {
            count[3]++;
          }

          if (choices[4] === "1") {
            count[2]++;
          } else if (choices[4] === "2") {
            count[1]++;
          } else if (choices[4] === "3") {
            count[3]++;
          } else if (choices[4] === "4") {
            count[0]++;
          }

          if (choices[5] === "1") {
            count[0]++;
          } else if (choices[5] === "2") {
            count[3]++;
          } else if (choices[5] === "3") {
            count[1]++;
          } else if (choices[5] === "4") {
            count[2]++;
          }
          // 책임형: "responsible", 감성형: "emotional", 현실형: "realistic", 신중형: "careful"
          if (answer.answer7 === "responsible") {
            count[0]++;
          } else if (answer.answer7 === "emotional") {
            count[1]++;
          } else if (answer.answer7 === "careful") {
            count[2]++;
          } else if (answer.answer7 === "realistic") {
            count[3]++;
          }

          if (answer.answer8 === "responsible") {
            count[0]++;
          } else if (answer.answer8 === "emotional") {
            count[1]++;
          } else if (answer.answer8 === "careful") {
            count[2]++;
          } else if (answer.answer8 === "realistic") {
            count[3]++;
          }

          // count를 비율을 나타내는 문자열로 변환
          const total = count.reduce((a, b) => a + b, 0);
          setPercentA(((count[0] / total) * 100).toFixed(0));
          setPercentB(((count[1] / total) * 100).toFixed(0));
          setPercentC(((count[2] / total) * 100).toFixed(0));
          setPercentD(((count[3] / total) * 100).toFixed(0));

          setIsFetched(true);
        }
      })
      .catch((err) => {
        console.log(err);
        if (fetchCount < 60) {
          setIsLoading(true);
          setIsError(false);

          setFetchCount(fetchCount + 1);
          setTimeout(() => {
            getResultFromServer(ticketId);
          }, 3500);
        } else {
          setIsLoading(false);
          setIsError(true);
        }
      });
  };

  const moveToEventPage = () => {
    window.open("https://www.instagram.com/p/DDnycyity_P", "_blank");
  };

  const downloadResultImage = function () {
    var link = document.createElement("a");
    link.download = "이혼보험 결과.png";
    link.href = imageData;
    link.click();
  };

  const countLines = (ctx, text, fieldWidth) => {
    let lines = [];
    let line = "";
    const fontSize = parseFloat(ctx.font);

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const tempLine = line + char;
      const tempWidth = ctx.measureText(tempLine).width;

      if (tempWidth < fieldWidth && char !== "\n") {
        line = tempLine;
      } else {
        lines.push(line);
        line = char === "\n" ? "" : char;
      }
    }
    lines.push(line);
    return lines.length;
  };

  const drawTextBox = (
    ctx,
    text,
    x,
    y,
    fieldWidth,
    spacing,
    center = false,
    underline = false
  ) => {
    // Build lines by iterating over each character.
    let lines = [];
    let line = "";
    const fontSize = parseFloat(ctx.font);

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const tempLine = line + char;
      const tempWidth = ctx.measureText(tempLine).width;

      if (tempWidth < fieldWidth && char !== "\n") {
        line = tempLine;
      } else {
        lines.push(line);
        line = char === "\n" ? "" : char;
      }
    }
    lines.push(line);

    // Center mode: center align horizontally and vertically around (x, y)
    if (center) {
      ctx.textAlign = "center";
      // Calculate total text height based on spacing.
      const totalHeight = lines.length * fontSize * spacing;
      // Adjust y so that the block of text is vertically centered.
      let startY = y - totalHeight / 2 + fontSize;
      for (let j = 0; j < lines.length; j++) {
        ctx.fillText(lines[j], x, startY + j * fontSize * spacing);
      }
    }
    // Left-align mode: x,y is the start point.
    else {
      ctx.textAlign = "start";
      let currentY = y;
      for (let j = 0; j < lines.length; j++) {
        ctx.fillText(lines[j], x, currentY);
        currentY += fontSize * spacing;
      }
    }

    if (underline) {
      // Draw underline for the previously rendered text (insuranceAdjective + " 보장!")
      const underlineText = nickname + "님을 위한 맞춤형 이혼 보험 설계";
      const textMetrics = ctx.measureText(underlineText);
      const textWidth = textMetrics.width;

      const underlineY = y + 40; // Adjust this offset as needed
      ctx.beginPath();
      if (center) {
        ctx.moveTo(x - textWidth / 2, underlineY);
        ctx.lineTo(x + textWidth / 2, underlineY);
      } else {
        ctx.moveTo(x, underlineY);
        ctx.lineTo(x + textWidth, underlineY);
      }
      ctx.lineWidth = 2;
      ctx.strokeStyle = "black";
      ctx.stroke();
    }
  };

  function KakaoShare() {
    // window.Kakao.Share.sendDefault({
    //   objectType: "text",
    //   imageUrl:
    //     "https://rd2.randomdiversity.com/app_cdn/divorce_insurance_banner.png",
    //   text: `${nickname}님의 맞춤 이혼보험 결과입니다!`,
    //   link: {
    //     mobileWebUrl: window.location.href,
    //     webUrl: window.location.href,
    //   },
    // });

    window.Kakao.Share.sendDefault({
      objectType: "feed",
      content: {
        title: "맞춤형 이혼보험 테스트 결과",
        description: `${nickname}님의 맞춤 이혼보험 결과입니다!`,
        imageUrl:
          "https://rd2.randomdiversity.com/app_cdn/divorce_insurance_banner.jpg",
        link: {
          mobileWebUrl: window.location.href,
          webUrl: window.location.href,
        },
      },
    });
  }

  return (
    <div className={styles.background}>
      <div className={styles.content}>
        {isLoading ? (
          nickname !== "" ? (
            <DivorceInsuranceLoading nickname={nickname} />
          ) : null
        ) : isError ? (
          <DivorceInsuranceError />
        ) : (
          <div>
            <div
              className={styles.headerWrapper}
              onClick={moveToEventPage}
            ></div>
            <div id="letterContainer" className={styles.letterContainer}>
              <img
                src={imageData}
                className={styles.letterCanvas}
                alt="result"
              />
            </div>

            {isIphone ? (
              <img
                className={styles.saveButton}
                src={PressAndSave}
                alt="saveButton"
              />
            ) : null}

            <div id="shareContainer" className={styles.shareContainer}>
              <img
                src={LinkShareImage}
                className={styles.shareImage}
                alt="linkShare"
                onClick={() => {
                  navigator.clipboard.writeText(window.location.href);
                  alert("결과페이지의 URL이 복사되었습니다.");
                }}
              />
              {isIphone ? null : (
                <img
                  src={DownloadImage}
                  className={styles.shareImage}
                  alt="downloadImage"
                  onClick={() => {
                    downloadResultImage();
                  }}
                />
              )}

              <img
                src={KakaoShareImage}
                className={styles.shareImage}
                alt="linkShare"
                onClick={() => {
                  KakaoShare();
                }}
              />
              <img
                src={XShareImage}
                className={styles.shareImage}
                alt="linkShare"
                onClick={() => {
                  // share to twitter(X)
                  const url = `https://twitter.com/intent/tweet?text=${nickname}님의 맞춤 이혼보험 결과입니다!&url=${window.location.href}`;
                  window.open(url, "_blank");
                }}
              />
            </div>
            <img
              className={styles.saveButton}
              src={ShareText}
              alt="shareText"
            />

            <div className={styles.detailContainer}>
              <div className={styles.detailTitle1}>
                {`플러스 손해보험 뉴라이프 이혼자 보장보험`}
                <br />
                {`${insuranceAdjective} 보장 특약`}
              </div>

              <div className={styles.detailTitle2}>
                <span style={{ color: "#fe7312" }}>‘{adjective}’</span> 당신을
                위한 <br />
                <span style={{ color: "#fe7312" }}>
                  ‘{insuranceAdjective} 보장’
                </span>
              </div>
              <div className={styles.detailTitle3}>{`[이혼보험 약관]`}</div>
              <div className={styles.detailContentSummary}>
                {`본 보험은 피보험자가 이혼으로 인해 발생할 수 있는 정신적, 경제적,`}
                <br />
                {`사회적 손실을 최소화하고, 원활한 재정 및 심리적 회복을 돕기 위해 설계된 상품입니다.`}
                <br />
                {`가입자의 성향 및 필요에 따라 맞춤형 특약을 추가할 수 있습니다.`}
              </div>

              <img src={Line} className={styles.line} alt="line" />

              <div
                className={styles.detailContentTitle}
              >{`제1조 (보장 개요)`}</div>

              <div className={styles.detailSpecific}>
                {`본 특약은 결혼 5년 이상 지속된 경우에 한하여 일정 기간 동안 생활비 지원, 자산 보호,`}
                <br />
                {`양육비 보장, 재정 및 심리적 회복 컨설팅을 제공합니다.`}
              </div>

              <img src={Line} className={styles.line} alt="line" />

              <div
                className={styles.detailContentTitle}
              >{`제2조 (보장 내용)`}</div>

              {letterContent.map((letter, index1) => (
                <div key={index1}>
                  <div className={styles.detailContentTitle}>{`${(
                    index1 + 1
                  ).toString()}. ${letter.title}`}</div>
                  {letter.contents.map((content, index2) => (
                    <div key={index2}>
                      <div className={styles.detailSpecific11}>
                        {`${(index1 + 1).toString()}-${(
                          index2 + 1
                        ).toString()}. ${content.content}`}
                      </div>
                      {content.specifics.map((specific, index3) => (
                        <div key={index3} className={styles.detailSpecific2}>
                          {` - ${specific}`}
                        </div>
                      ))}
                    </div>
                  ))}
                  <img src={Line} className={styles.line} alt="line" />
                </div>
              ))}

              <div
                className={styles.detailContentTitle}
              >{`제3조 (보험금 지급 조건 및 면책 사항)`}</div>

              <div className={styles.detailSpecific1}>
                {`1.보험금 지급은 법적으로 이혼이 확정된 경우에만 가능하며, 부정행위 또는 계약 위반으로 인한
    이혼은 보장에서 제외될 수 있습니다.`}
              </div>
              <div className={styles.detailSpecific1}>
                {`2.보험금은 재정 자립을 위한 노력이 확인된 경우 지급되며, 피보험자의 경제적 상태에 따라
    지급 방식이 조정될 수 있습니다.`}
              </div>
              <div className={styles.detailSpecific1}>
                {`3.본 특약 가입 후 1년 이내에 이혼이 발생할 경우, 보장 금액이 일부 제한될 수 있습니다.`}
              </div>

              <img src={Line} className={styles.line} alt="line" />
            </div>

            <div className={styles.eventContainer}>
              <img
                src={TryButton}
                alt="eventHeader"
                className={styles.eventButton}
                onClick={() => {
                  window.open(
                    "https://tvn.cjenm.com/ko/event/The-Divorce-insurance-Plan-Customization/",
                    "_blank"
                  );
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
